class CustomPackageWidget extends HTMLElement {
    constructor() {
        super();
        this.handleVariantSelected = this.handleVariantSelected.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleSellingPlanChange = this.handleSellingPlanChange.bind(this);
        this.handleCoffeeTypeChange = this.handleCoffeeTypeChange.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
    }

    connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.initWidget();
        window.addEventListener("variant:selected", this.handleVariantSelected);
        window.addEventListener("variant:change", this.handleVariantSelected);
        window.addEventListener("pageshow", this.handlePageShow);
        this.variantDataSelect = document.getElementById('esa__variant-data');
        this.priceEl = document.querySelector('.esa__custom-price-span');
        this.updatePrice();
    }

    disconnectedCallback() {
        window.removeEventListener("variant:selected", this.handleVariantSelected);
        window.removeEventListener("variant:change", this.handleVariantSelected);
        window.removeEventListener("pageshow", this.handlePageShow);

        if (this.quantityInputs) {
            this.quantityInputs.forEach(input => input.removeEventListener("change", this.handleQuantityChange));
        }
        if (this.sellingPlanInputs) {
            this.sellingPlanInputs.forEach(input => input.removeEventListener("change", this.handleSellingPlanChange));
        }
        if (this.coffeeTypeInputs) {
            this.coffeeTypeInputs.forEach(input => input.removeEventListener("change", this.handleCoffeeTypeChange));
        }
    }

    initWidget() {
        this.coffeeGroups = this.querySelectorAll(".coffee-select-group");
        this.attachQuantityListeners();
        this.syncWithCurrentQuantity();

        this.sellingPlanInputs = this.querySelectorAll('input[name="selling_plan_custom"]');
        this.sellingPlanInput = this.querySelector('input[type="hidden"][name="selling_plan"]');
        this.attachSellingPlanListeners();
        this.handleSellingPlanChange();

        this.coffeeTypeInputs = this.querySelectorAll('select[name*="coffee type"]');
        this.coffeeTypeInputs.forEach(input => input.addEventListener("change", this.handleCoffeeTypeChange));
        this.coffeeTypeInputs.forEach(input => this.handleCoffeeTypeChange({ target: input }));
    }

    attachSellingPlanListeners() {
        this.sellingPlanInputs.forEach(input => input.addEventListener("change", this.handleSellingPlanChange));
    }

    handleCoffeeTypeChange(event) {
        const coffeeTypeSelect = event.target;
        const group = coffeeTypeSelect.closest(".coffee-select-group");
        if (!group) return;

        const grindSelect = group.querySelector('select[name*="coffee grind"]');
        if (!grindSelect) return;

        const groundOption = Array.from(grindSelect.options).find(option => option.value === "Ground");
        if (!groundOption) return;

        if (coffeeTypeSelect.value === "Italian Espresso") {
            groundOption.disabled = true;

            if (grindSelect.value === "Ground") {
                grindSelect.value = "Whole Bean";
                grindSelect.dispatchEvent(new Event("change", { bubbles: true }));
            }
        } else {
            groundOption.disabled = false;
        }
    }

    handleSellingPlanChange() {
        if (!this.sellingPlanInput) return;

        const selectedPlan = this.querySelector('input[name="selling_plan_custom"]:checked');

        if (selectedPlan) {
            this.sellingPlanInput.value = selectedPlan.value;
            this.sellingPlanInput.disabled = false;
        } else {
            this.sellingPlanInput.value = "";
            this.sellingPlanInput.disabled = true;
        }
    }

    attachQuantityListeners() {
        if (!this.sectionId) return;

        const picker = document.querySelector(`variant-picker[data-section-id="${this.sectionId}"]`);
        if (!picker) return;

        this.quantityInputs = picker.querySelectorAll('fieldset[data-option-id*="quantity"] input[type="radio"]');
        this.quantityInputs.forEach(input => input.addEventListener("change", this.handleQuantityChange));
    }

    handleQuantityChange(event) {
        const value = event.target.value;
        this.updateVisibility(value);
    }

    handleVariantSelected() {
        this.syncWithCurrentQuantity();
        this.handleSellingPlanChange();
        this.updatePrice();
    }

    syncWithCurrentQuantity() {
        const picker = document.querySelector(`variant-picker[data-section-id="${this.sectionId}"]`);
        if (!picker) return;

        const checked = picker.querySelector('fieldset[data-option-id*="quantity"] input[type="radio"]:checked');

        const value = checked ? checked.value : "2 Bags";
        this.updateVisibility(value);
    }

    handlePageShow() {
        const firstPlan = this.querySelector('input[name="selling_plan_custom"]');

        this.sellingPlanInputs.forEach(input => {
            input.checked = false;
        });

        if (firstPlan) {
            firstPlan.checked = true;
        }

        this.handleSellingPlanChange();
    }

    updateVisibility(selectedQtyText) {
        const number = parseInt((selectedQtyText || "").split(" ")[0], 10);
        const selectedNumber = isNaN(number) ? 2 : number;

        this.coffeeGroups.forEach((group, index) => {
        const selects = group.querySelectorAll("select");

        if (index < 2) {
            group.style.display = "block";
            selects.forEach(sel => sel.disabled = false);
            return;
        }

        if (index < selectedNumber) {
            group.style.display = "block";
            selects.forEach(sel => sel.disabled = false);
        } else {
            group.style.display = "none";
            selects.forEach(sel => {
                sel.disabled = true;
                sel.selectedIndex = 0;
            });
        }
        });
    }
    updatePrice() {
        setTimeout(() => {
            const params = new URLSearchParams(window.location.search);
            const variantId = params.get('variant');

            if (!variantId || !this.variantDataSelect) return;
            
            const matchedOption = this.variantDataSelect.querySelector(`option[value="${variantId}"]`);
            
            if (!matchedOption) return;
    
            const price = matchedOption.dataset.price;
            const subPrice = matchedOption.dataset.subPrice;
    
            if (this.priceEl) {
              this.priceEl.innerHTML = `<del>${price}</del> ${subPrice}`;
            }
        }, 500);
        
    }
}

customElements.define("custom-package-widget", CustomPackageWidget);